import * as React from 'react';
const BackgroundBlue = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={397} height={1024} fill="none" {...props}>
    <g filter="url(#a)" opacity={0.7}>
      <circle cx={-757} cy={1000} r={1054} fill="#E8F2FF" />
    </g>
    <defs>
      <filter
        id="a"
        width={2308}
        height={2308}
        x={-1911}
        y={-154}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_3377_83756" stdDeviation={50} />
      </filter>
    </defs>
  </svg>
);
export default BackgroundBlue;
